import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
// SHARED

// LOCAL
import NewMainContent from './NewMainContent'
import { createMemberInvites, resetCreateMemberInvitesForm } from './actions'

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleNewMemberFormSubmit: (values)=> dispatch(createMemberInvites(values)).then(e=>console.log('promise returns:',e)),
    handleCreateMemberInvitesFormReset: ()=> dispatch(resetCreateMemberInvitesForm()),
    handleFocus: (event) => event.target.select()
  }
}
const mapStateToProps = (state)=> {
  return {
      ...state.models,
      ...state.enterprise
  }
}

const New = ({user, ui, invited, showCheckmark, handleCreateMemberInvitesFormReset, handleNewMemberFormSubmit, handleFocus}) =>
  <NewMainContent
    user={user}
    ui={ui}
    onCreateMemberInvitesFormReset={handleCreateMemberInvitesFormReset}
    onNewMemberFormSubmit={handleNewMemberFormSubmit}
    handleSubmit={handleNewMemberFormSubmit}
    handleFocus={handleFocus}
    showCheckmark={showCheckmark}
    invited={invited}
  />


export default connect(mapStateToProps, mapDispatchToProps)(New)



// WEBPACK FOOTER //
// ./src/enterprise/members/New.js